const SignupStep = () => {
    return `
    <section class="signup-step-container">
        <div class="d-flex justify-content-center">
            <div class="col-lg-8">
                <div class="wizard">
                    <div class="wizard-inner">
                        <div class="connecting-line"></div>
                        <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" id="step-1">
                            <a
                            data-toggle="tab"
                            aria-controls="step1"
                            role="tab"
                            aria-expanded="true"
                            ><span class="round-tab">1</span> <i class="trn" data-trn-key="phoneNumberInput">携帯電話番号入力</i></a
                            >
                        </li>
                        <li role="presentation" id="step-2">
                            <a
                            data-toggle="tab"
                            aria-controls="step2"
                            role="tab"
                            aria-expanded="false"
                            ><span class="round-tab">2</span> <i class="trn" data-trn-key="otpVerification">認証番号入力</i></a
                            >
                        </li>
                        <li role="presentation" id="step-3">
                            <a
                            data-toggle="tab"
                            aria-controls="step3"
                            role="tab"
                            id="heel3"
                            ><span class="round-tab">3</span> <i class="trn" data-trn-key="singup">会員情報入力</i></a
                            >
                        </li>
                        <li role="presentation" id="step-4">
                            <a
                            data-toggle="tab"
                            aria-controls="step4"
                            role="tab"
                            ><span class="round-tab">4</span> <i class="trn" data-trn-key="compleleMemberRegistration">会員登録完了</i></a
                            >
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>`
}

export default SignupStep
